import type { CamelCasedPropertiesDeep } from 'type-fest';

import { GooglePlacesObject } from './googlePlacesObject';

export type AddressApiResponse = {
  uuid: string;
  printable_address: string;
  is_parent_billing?: boolean;
  street: string;
  street_line_2?: string;
  city: string;
  state: string;
  postal_code: string;
  latitude?: string;
  longitude?: string;
  service_address_id: number;
  notes: string | null;
  billing: boolean;
  is_deletable: boolean;
};

export type Address = CamelCasedPropertiesDeep<AddressApiResponse>;

export function mapGoogleObjectToAddress(newAddress: Partial<GooglePlacesObject>): Address {
  return {
    billing: false,
    city: newAddress.city ?? '',
    isDeletable: false,
    latitude: newAddress.latitude?.toString() ?? '',
    longitude: newAddress.longitude?.toString() ?? '',
    notes: '',
    postalCode: newAddress.postal_code ?? '',
    printableAddress: newAddress.formatted_address ?? '',
    serviceAddressId: 0,
    state: newAddress.state ?? '',
    street: newAddress.street ?? '',
    streetLine2: newAddress.street_line_2 ?? '',
    uuid: '',
  };
}
